import { render, staticRenderFns } from "./NormalSearchNav88.vue?vue&type=template&id=386a1586&scoped=true&"
import script from "./NormalSearchNav88.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav88.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386a1586",
  null
  
)

export default component.exports